import { Box, Grid, Typography } from "@material-ui/core";
import { FormStore } from "@roc/feature-app-core";
import { createTextField } from "@roc/feature-one-tool";
import { observer } from "mobx-react";

interface WireAuthorizationFormProps {
  store: FormStore;
}

export const WireAuthorizationForm = observer(({ store }: WireAuthorizationFormProps) => {
  const formDisabled = true;

  return (
    <Box display="flex" flexDirection="column" gridGap="1rem">
      <Typography variant="h6">
        Draw Lender Details
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'Bank Name',
            fieldName: 'bankName',
            testId: 'bankName',
            store,
            standaloneLabel: false,
            disabled: formDisabled
          })}
        </Grid>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'Routing Number',
            fieldName: 'routingNumber',
            testId: 'routingNumber',
            store,
            standaloneLabel: false,
            disabled: formDisabled
          })}
        </Grid>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'Account Name',
            fieldName: 'accountName',
            testId: 'accountName',
            store,
            standaloneLabel: false,
            disabled: formDisabled
          })}
        </Grid>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'Account Number',
            fieldName: 'accountNumber',
            testId: 'accountNumber',
            store,
            standaloneLabel: false,
            disabled: formDisabled
          })}
        </Grid>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'Street Name',
            fieldName: 'streetName',
            testId: 'streetName',
            store,
            standaloneLabel: false,
            disabled: formDisabled
          })}
        </Grid>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'City',
            fieldName: 'city',
            testId: 'city',
            store,
            standaloneLabel: false,
            disabled: formDisabled
          })}
        </Grid>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'Zip Code',
            fieldName: 'zipCode',
            testId: 'zipCode',
            store,
            standaloneLabel: false,
            disabled: formDisabled
          })}
        </Grid>
        <Grid item xs={12} md={6} >
          {createTextField({
            store: store,
            testId: 'state',
            fieldName: 'state',
            label: 'Entity State',
            standaloneLabel: false,
            disabled: formDisabled
          })}
        </Grid>
      </Grid>
      <Typography variant="h6" gutterBottom>
        FFC Bank Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'FFC Bank Name',
            fieldName: 'ffcBankName',
            testId: 'ffcBankName',
            store,
            standaloneLabel: false,
            disabled: formDisabled
          })}
        </Grid>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'FFC Routing Number',
            fieldName: 'ffcRoutingNumber',
            testId: 'ffcRoutingNumber',
            store,
            standaloneLabel: false,
            disabled: formDisabled
          })}
        </Grid>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'FFC Account Name',
            fieldName: 'ffcAccountName',
            testId: 'ffcAccountName',
            store,
            standaloneLabel: false,
            disabled: formDisabled
          })}
        </Grid>
        <Grid item xs={12} md={6} >
          {createTextField({
            label: 'FFC Account Number',
            fieldName: 'ffcAccountNumber',
            testId: 'ffcAccountNumber',
            store,
            standaloneLabel: false,
            disabled: formDisabled
          })}
        </Grid>
      </Grid>
    </Box>);
});
